<div class="modal-header primaryBgColor grayFontColor">
    <h5 class="modal-title">Eltern ausw&auml;hlen</h5>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <span ngbAutofocus tabindex="-1"></span>
    <app-filter [categories]="categories"
                [(query)]="query"
                [useUrlBar]="false"
                (queryChange)="updateFilter()"></app-filter>

    <div *ngIf="eltern.length === 0" class="text-center py-4">
        Keine Eltern gefunden.
    </div>

    <div class="list-group">
        <button class="list-group-item list-group-item-action d-flex justify-content-between align-items-center primaryBgColor grayFontColor"
                *ngFor="let elternteil of eltern"
                (click)="select(elternteil)">
            <div>
                <div class="font-weight-bold">{{ elternteil.vorname }} {{ elternteil.nachname }}</div>
                <div class="small">{{ elternteil.mail || '---' }}</div>
                <div class="small">{{ elternteil.strasse }} {{ elternteil.hausnummer }}, {{ elternteil.plz }} {{ elternteil.ort }}</div>
            </div>
            <span class="badge badge-secondary badge-pill">{{ elternteil.kinder.length }} Kinder</span>
        </button>
    </div>
</div>

<div class="modal-footer">
    <button class="btn scButton" (click)="activeModal.dismiss()">Abbrechen</button>
</div>
